/* eslint-disable complexity */
import React from 'react'
import CastAndCrew from './CastAndCrew'
import AwsConfig from '../../Config/AwsConfig'
import { FiEdit2 } from 'react-icons/fi'
import {
  CSSStylesLocal1,
  CSSStylesLocal11,
  CSSStylesLocalcast,
  CSSStylesLocalcast11,
  CSSStylesLocal2,
  heightChangeDiv1,
  heightChangeDiv2,
  heightChangeDiv3,
  displayNoneStyleCast,
  displayNoneStyle,
} from '../Data/MovieStaticData'
//
function CellReturn(props) {
  const {
    readmoreforcast,
    value,
    readmorecast,
    path,
    isFoundPOsterURL,
    isReadMore,
    GetFormattedDateforlistmovies,
    localValue,
    Doubleclickchip,
    singleClickcast,
    singleClickcrew,
    toggleReadMore,
    isFound,
    handleEditClick,
  } = props

  return (
    <div
      className='mainpathdiv'
      style={
        readmorecast
          ? heightChangeDiv1.main
          : path === 'movieCast' || path === 'movieCast_Te'
          ? heightChangeDiv3.main
          : heightChangeDiv2.main
      }
    >
      {isFoundPOsterURL ? null : (
        <div
          className='localval'
          style={
            path === 'about_En' || path === 'about_Te'
              ? isReadMore
                ? CSSStylesLocal1.main
                : CSSStylesLocal11.main
              : CSSStylesLocal2.main
          }
        >
          <div
            className='localval'
            style={
              path === 'movieCast' || path === 'movieCast_Te'
                ? isReadMore
                  ? CSSStylesLocalcast.main
                  : CSSStylesLocalcast11.main
                : null
            }
          >
            {' '}
            {path === 'ottReleasedDate' /* || path === 'ottReleasedDateUI' */ ||
            path === 'allMoviesReleasedDate' ||
            path === 'movieReleasedDateUI' ? (
              <div>{GetFormattedDateforlistmovies(localValue)}</div>
            ) : null}
            {path === 'genre_En' || path === 'genre_Te' || path === 'ottPlatform' ? (
              <div>{localValue && localValue.filter(item => item !== '').join()} </div>
            ) : null}
            {Array.isArray(localValue) ? (
              <CastAndCrew
                path={path}
                readmorecast={readmorecast}
                localValue={localValue}
                displayNoneStyle={displayNoneStyle}
                singleClickcrew={singleClickcrew}
                singleClickcast={singleClickcast}
                displayNoneStyleCast={displayNoneStyleCast}
                Doubleclickchip={Doubleclickchip}
              />
            ) : path === 'ottReleasedDate' ||
              path === 'allMoviesReleasedDate' ||
              path === 'movieReleasedDateUI' ? (
              ''
            ) : path === 'about_En' || path === 'about_Te' ? (
              <p className='text'>
                {isReadMore ? (
                  <div className='lessspace'>{localValue.slice(0, 200)}</div>
                ) : (
                  <div className='morespace'>{localValue}</div>
                )}
                <span onClick={toggleReadMore} className='read-or-hide'>
                  {localValue.length >= 200 ? (
                    isReadMore ? (
                      <div>
                        <b>...read more</b>
                      </div>
                    ) : (
                      <div>
                        <b>read less</b>
                      </div>
                    )
                  ) : (
                    ''
                  )}
                </span>
              </p>
            ) : (
              localValue
            )}{' '}
          </div>{' '}
        </div>
      )}
      {isFound ? (
        ''
      ) : (
        <div>
          <FiEdit2 onClick={() => handleEditClick()}>edit</FiEdit2>
        </div>
      )}
      {path === 'posterURL' ? (
        <img
          style={{ height: '150px', width: '7rem', objectFit: 'cover' }}
          src={AwsConfig.movieCdnUrl + value}
        />
      ) : null}
      {path === 'movieCast' || path === 'movieCast_Te' ? (
        localValue.length > 10 ? (
          readmorecast ? (
            <div onClick={readmoreforcast}>
              <b>read less</b>
            </div>
          ) : (
            <div onClick={readmoreforcast}>
              <b>...read more</b>
            </div>
          )
        ) : (
          ''
        )
      ) : (
        ''
      )}
      {path === 'tags' || path === 'adminTagsGood' || path === 'adminTagsBad' ? (
        <div>{localValue.toString()}</div>
      ) : null}
    </div>
  )
}

export default CellReturn
